import LegalScreenConnector from './LegalScreenConnector';

export default LegalScreenConnector;
